import { PageURL } from 'router/pageURL';

export const criteriasList = [
  { textId: 'applicationForm.CRITERIA.options.bankruptcy' },
  { textId: 'applicationForm.CRITERIA.options.repossession' },
  { textId: 'applicationForm.CRITERIA.options.ccj' },
  { textId: 'applicationForm.CRITERIA.options.debtRelief' },
  { textId: 'applicationForm.CRITERIA.options.dmp' },
  { textId: 'applicationForm.CRITERIA.options.taxResident', link: PageURL.RECIDENCY_REQUIREMENTS },
  { textId: 'applicationForm.CRITERIA.options.minimumDeposit', link: PageURL.INCOME_REQUIREMENTS },
  { textId: 'applicationForm.CRITERIA.options.minorTrafficOffence' },
];
